import { render, staticRenderFns } from "./DrzavaForma.vue?vue&type=template&id=218206f0&scoped=true&"
import script from "./DrzavaForma.vue?vue&type=script&lang=js&"
export * from "./DrzavaForma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218206f0",
  null
  
)

export default component.exports